import { defineMessages } from 'react-intl';

export default defineMessages({
    covSpoAndRec: {
        id: 'quoteandbind.SpoAndRecLinedirectives.templates.SpoAndRec.Coverages',
        defaultMessage: 'Coverages'
    },
    formSpoAndRec:{
        id: 'quoteandbind.SpoAndRecLinedirectives.templates.SpoAndRec.Endorsements',
        defaultMessage: 'Endorsements'
    }
});